export const SHIPMENT_SERVICE_ENDPOINT = {
  CREATE_SHIPMENT: '/createShipment',
  COMMENTS: '/comments',
  SHIPMENT_TRACKING_INFO: '/shipmentTrackingInfo'
};
